import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Store } from '@ngrx/store';
import { switchMap, take } from 'rxjs/operators';
import { selectInfo } from '../../store/info/info.selectors';
import { correlationIdSelector } from '../../store/samoobsluga/samoobsluga.selectors';
import {LinkActivityLog} from './types/link-activity-log';
import {Log} from './types/log';
import {Observable} from 'rxjs';

@Injectable()
export class LoggingService {
  private correlationId !: string;

  constructor(private http: HttpClient,
              private store: Store) {
  }

  log(log: Log): Observable<any> {
    return this.http.post(this.createInitUrl(), log)
  }

  logLinkActivity(log: LinkActivityLog): Observable<any> {
    this.store.select(correlationIdSelector).subscribe(id => this.correlationId = id);
    return this.store.select(selectInfo).pipe(
      take(1),
      switchMap(appInfo =>
        this.log({
          appInfo,
          error: undefined,
          correlationId: this.correlationId,
          logInfo: JSON.stringify(log),
          logType: 'LINK_ACTIVITY'
        })
      )
    )
  }

  private createInitUrl(): string {
    return '/sag/logs/'
  }
}
